import { Stack, Typography } from "@mui/material";
import { except } from "@entrilia/shared/utilities/arrayHelper";
import type {
  CurrencyEntityFieldConfiguration,
  EntityFieldConfiguration,
  NumberScaleFormat,
} from "../../../../../api/types/objectTypes";
import { allNumberScaleFormats } from "../../../../../api/types/objectTypes";
import NumberPrecisionSelect from "../../../../common/NumberPrecisionSelect";
import CurrencySelect from "./CurrencySelect";
import ScaleFormatSelect from "./ScaleFormatSelect";

const moneyScaleFormats = except<NumberScaleFormat>([...allNumberScaleFormats], ["Multiple"]);

interface Props {
  fieldConfiguration: CurrencyEntityFieldConfiguration;
  readOnly?: boolean;
  onChange: (fieldConfiguration: EntityFieldConfiguration) => void;
}

const MoneyFieldConfigEditor = ({ fieldConfiguration, readOnly, onChange }: Props) => {
  return (
    <Stack spacing={1} sx={{ pt: 2 }}>
      <Typography variant="subtitle2">Formatting</Typography>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography color="textSecondary">Currency</Typography>
        <CurrencySelect
          code={fieldConfiguration.currencyCode || "USD"}
          onChange={(currencyCode) => onChange({ ...fieldConfiguration, currencyCode })}
          sx={{ width: "12rem" }}
        />
      </Stack>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography color="textSecondary">Precision</Typography>
        <NumberPrecisionSelect
          maxPrecision={6}
          precision={fieldConfiguration.precision || 0}
          disabled={readOnly}
          onPrecisionChange={(precision) => onChange({ ...fieldConfiguration, precision })}
          sx={{ width: "12rem" }}
        />
      </Stack>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography color="textSecondary">Display Style</Typography>
        <ScaleFormatSelect
          value={fieldConfiguration.scaleFormat}
          options={moneyScaleFormats}
          disabled={readOnly}
          onChange={(scaleFormat) => onChange({ ...fieldConfiguration, scaleFormat })}
        />
      </Stack>
    </Stack>
  );
};

export default MoneyFieldConfigEditor;
